module.exports = __webpack_public_path__ + "media/images/icon-arrow-ur-large-74d2a216c656b6b08cb4a1cf02caf350.png";